var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "qrcode",
        attrs: { id: "qrcode" }
      },
      [
        _vm.qrcodeUrl
          ? _c("img", {
              staticClass: "qrcodeImg",
              attrs: { src: _vm.qrcodeUrl }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 1 && !_vm.agreeXieyi
          ? _c("div", { staticClass: "fail_mask" }, [
              _c("span", { staticClass: "agreeXieyiTxt" }, [
                _vm._v(_vm._s(_vm.$t("m.please_agree_agree")))
              ])
            ])
          : _vm.qrCodeTimeOut
          ? _c(
              "div",
              {
                staticClass: "fail_mask",
                on: {
                  click: function($event) {
                    return _vm.getQrcodeInfo()
                  }
                }
              },
              [_vm._m(0)]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "direction_ltr scantip" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("m.open_code")) + "\n    "),
      _c("img", {
        staticClass: "scanicon",
        attrs: { src: require("../assets/img/scan.png") }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "refreshbox" }, [
      _c("img", {
        staticClass: "qrcode_ref_icon",
        attrs: { src: require("../assets/img/refresh.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5aeefe6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5aeefe6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scan.vue
// module id = null
// module chunks = 